import { BankStatementAccount, BankStatementTransactionRow } from '../domain/bank.domain';

export type BsaConfirmedTransactionSnapshot = {
  loanPaymentTransactions?: BankStatementTransactionRow[] | null;
  incomeTransactions?: BankStatementTransactionRow[] | null;
  atoPaymentTransactions?: BankStatementTransactionRow[] | null;
};

export type RestoredBsaConfirmedTransactions = {
  loanPaymentTransactions: BankStatementTransactionRow[];
  incomeTransactions: BankStatementTransactionRow[];
  atoPaymentTransactions: BankStatementTransactionRow[];
  confirmLoanPayment: boolean;
  confirmIncome: boolean;
  confirmAtoPayment: boolean;
};

const asTransactionRows = (value: unknown): BankStatementTransactionRow[] =>
  Array.isArray(value) ? value : [];

export const resolveBsaSelectedAccountIds = (
  accounts: Pick<BankStatementAccount, 'id' | 'isLatestVersion'>[],
  savedIds: string[] | null | undefined,
): string[] => {
  const currentIds = new Set(accounts.map(account => account.id));
  const restored = (Array.isArray(savedIds) ? savedIds : []).filter(id => currentIds.has(id));
  if (restored.length) {
    return restored;
  }
  return accounts.filter(account => account.isLatestVersion !== false).map(account => account.id);
};

export const restoreBsaConfirmedTransactions = (
  saved: BsaConfirmedTransactionSnapshot | null | undefined,
): RestoredBsaConfirmedTransactions => {
  const loanPaymentTransactions = asTransactionRows(saved?.loanPaymentTransactions);
  const incomeTransactions = asTransactionRows(saved?.incomeTransactions);
  const atoPaymentTransactions = asTransactionRows(saved?.atoPaymentTransactions);
  return {
    loanPaymentTransactions,
    incomeTransactions,
    atoPaymentTransactions,
    confirmLoanPayment: loanPaymentTransactions.length > 0,
    confirmIncome: incomeTransactions.length > 0,
    confirmAtoPayment: atoPaymentTransactions.length > 0,
  };
};
